export const appShowLoader = () => ({
    type: 'APP_LOADER_SHOW',
});

export const appHideLoader = () => ({
    type: 'APP_LOADER_HIDE',
});